<template>
    <v-dialog v-model="show" max-width="390" persistent no-click-animation>
        <div class="AgentCreator">
            <div class="dialog-header">
                <div>{{ agent ? $f.tc('edit') : $f.tc('add') }} {{ $f.tc('tova') }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" ref="form" @submit="submit" style="padding: 12px">
                <div class="mb-12" v-if="nlpName">
                    <div class="label">{{ $t('treeNode.setting.currentNlp') }}</div>
                    <div style="font-size: 14px;">{{ nlpName }}</div>
                </div>
                <div class="label">{{ $f.tc('name') }}</div>
                <v-text-field
                    outlined
                    v-model="model.name"
                    :rules="formRules.required"
                    class="input-custom mb-12"
                ></v-text-field>
                <div class="label">{{ $f.tc('bot') }} {{ $f.tc('code') }}</div>
                <v-text-field
                    outlined
                    v-model="model.bot_code"
                    :rules="formRules.required"
                    class="input-custom mb-12"
                ></v-text-field>
                <div class="label">{{ $f.tc('brokerId') }}</div>
                <v-text-field
                    outlined
                    v-model="model.broker_id"
                    :rules="formRules.required"
                    class="input-custom"
                ></v-text-field>
                <div class="label">{{ $f.tc('key') }}</div>
                <v-text-field
                    outlined
                    v-model="model.secret_key"
                    :rules="formRules.required"
                    class="input-custom"
                ></v-text-field>
            </v-form>
            <div class="dialog-footer">
                <div class="btn-custom"
                     @click="submit">{{ (agent ? $f.tc('save') : $f.tc('create')) }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import {mapState} from "vuex";
import AgentService from "@/services/agent.service";

export default {
    name: "AgentCreator",
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            nlpName: '',
            model: {
                name: '',
                broker_id: '',
                bot_code: '',
                secret_key: ''
            },
            agent: null,
            isEditing: false
        }
    },
    computed: {
        ...mapState({})
    },
    methods: {
        open(agent) {
            this.clearForm()
            this.agent = agent
            if (agent) {
                this.isEditing = true
                this.model = {
                    name: agent.name,
                    broker_id: agent.broker_id,
                    bot_code: agent.bot_code,
                    secret_key: agent.secret_key
                }
            } else {
                this.isEditing = false
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        clearForm() {
            this.$refs.form.resetValidation()
            this.nlpName = ''
            this.model = {
                name: '',
                broker_id: '',
                bot_code: '',
                secret_key: '',
            }
        },
        submitValidForm() {
            this.$appService.showLoading()

            // update agent
            if (this.agent) {
                this.updateScenario(this.model)
                return
            }

            // create new agent
            this.createScenario(this.model)
        },
        updateScenario(model) {
            let i18n = {
                action: this.$t('update'),
                item: this.$t('tova')
            }
            AgentService.CRUD.update(this.agent.id, model).then(
                () => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.close()
                    this.promise.resolve()
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
        },
        createScenario(model) {
            let i18n = {
                action: this.$t('create'),
                item: this.$t('tova')
            }
            AgentService.CRUD.create(model).then(
                result => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.close()
                    this.promise.resolve(result.data)
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
        },
    }
}
</script>

<style scoped lang="scss">
.AgentCreator {
    background: #FFFFFF;
    position: relative;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        font-family: "open sans bold", serif;
        font-size: 13px;
        margin-bottom: 2px !important;
    }
}

.btn-custom {
    margin-right: 8px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;
            outline: none;
            outline-offset: 0;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 9px
    }

    .v-select {
        .v-text-field__details {
            right: 28px !important;
        }

        &.input-custom {
            .v-input__slot {
                padding-right: 2px !important;
            }
        }
    }

    .input-custom:has(.error--text) {
        .v-input__slot {
            border-color: #ff5252 !important;
        }
    }

    .input-custom.v-input--is-focused {
        .v-input__slot {
            outline: 2px solid #FF52526B;
        }

        &:not(.error--text) {
            .v-input__slot {
                outline: 2px solid #0052CC6B;
                border-color: #0052CC !important;
            }
        }
    }

    .v-input--selection-controls__ripple {
        width: 0 !important;
        height: 0 !important;
    }

    .v-label {
        font-family: "open sans", serif !important;
        font-size: 14px !important;
        color: #000;
    }

    .v-input--selection-controls {
        margin-top: 14px !important;
        padding-top: 0 !important;
    }
}
</style>
